export const autocompleteFields = /* GraphQL */ `
  fragment autocompleteFields on AutocompleteResult {
    text
    image
    url
  }
`
